import React, { useState } from 'react'

const videos = [
  {
    id: 'vplUv0K9AJs',
    title: 'Sewa Bharti Haryana – Our Work',
    desc: 'A glimpse into the welfare activities conducted by Sewa Bharti Haryana Pradesh across the state.',
    tag: 'Featured',
  },
  {
    id: 'vplUv0K9AJs',
    title: 'Medical Camp – Free Health Services',
    desc: 'Free medical consultations and medicines provided to hundreds of underprivileged families.',
    tag: 'Health',
  },
  {
    id: 'vplUv0K9AJs',
    title: 'Education Initiative – Bright Futures',
    desc: 'Schools and skill centres run by Sewa Bharti empowering children and youth across Haryana.',
    tag: 'Education',
  },
  {
    id: 'vplUv0K9AJs',
    title: 'Disaster Relief Operations',
    desc: 'Swift relief distribution to flood-affected families in Haryana — food, clothing, and essentials.',
    tag: 'Relief',
  },
  {
    id: 'vplUv0K9AJs',
    title: 'Skill Training – Empowering Women',
    desc: 'Vocational skill training centres giving women the tools to earn a dignified, independent livelihood.',
    tag: 'Self-Reliance',
  },
  {
    id: 'vplUv0K9AJs',
    title: 'Community Harmony Events',
    desc: 'Cultural and community gatherings that promote unity, tolerance, and brotherhood across society.',
    tag: 'Community',
  },
]

function VideoCard({ video, onClick }) {
  return (
    <div className="rounded-2xl overflow-hidden bg-white transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
      style={{border:'1px solid rgba(0,0,0,0.07)',boxShadow:'0 2px 14px rgba(13,27,62,0.06)'}}
      onClick={onClick}>
      {/* Thumbnail */}
      <div className="relative" style={{paddingBottom:'56.25%',background:'#0D1B3E'}}>
        <img
          src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
          alt={video.title}
          className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-60 transition-opacity"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-14 h-14 rounded-full flex items-center justify-center transition-transform group-hover:scale-110"
            style={{background:'rgba(232,103,10,0.9)',boxShadow:'0 4px 20px rgba(232,103,10,0.5)'}}>
            <svg className="w-6 h-6 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
              <polygon points="5 3 19 12 5 21 5 3"/>
            </svg>
          </div>
        </div>
        <div className="absolute top-3 left-3">
          <span className="text-xs font-semibold px-2.5 py-1 rounded-full" style={{background:'var(--saffron)',color:'white'}}>
            {video.tag}
          </span>
        </div>
      </div>
      <div className="p-5">
        <h3 className="font-semibold mb-2 leading-snug" style={{color:'var(--navy)',fontFamily:'Playfair Display,serif',fontSize:'15px'}}>{video.title}</h3>
        <p className="text-sm leading-relaxed" style={{color:'var(--muted)'}}>{video.desc}</p>
        <div className="flex items-center gap-1.5 mt-3 text-xs font-medium" style={{color:'var(--saffron)'}}>
          <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24"><polygon points="5 3 19 12 5 21 5 3"/></svg>
          Watch Video
        </div>
      </div>
    </div>
  )
}

export default function Videos() {
  const [playing, setPlaying] = useState(null)

  return (
    <div>
      <div className="page-header">
        <div className="max-w-7xl mx-auto px-4">
          <h1>Videos</h1>
          <p className="breadcrumb">Home › Gallery › Videos</p>
        </div>
      </div>

      <section className="py-16" style={{background:'var(--cream)'}}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="section-tag" style={{justifyContent:'center'}}>Our Video Gallery</div>
            <h2 className="mb-3" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(26px,4vw,40px)',fontWeight:700,color:'var(--navy)'}}>
              Watch Our Work
            </h2>
            <p style={{color:'var(--muted)',maxWidth:'520px',margin:'0 auto',lineHeight:1.8}}>
              Witness the impact of Sewa Bharti Haryana's work through these videos from our programmes across the state.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {videos.map((v, i) => (
              <VideoCard key={i} video={v} onClick={() => setPlaying(v.id)}/>
            ))}
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {playing && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
          style={{background:'rgba(0,0,0,0.92)'}}
          onClick={() => setPlaying(null)}>
          <div className="relative w-full" style={{maxWidth:'900px'}} onClick={e => e.stopPropagation()}>
            <div style={{paddingBottom:'56.25%',position:'relative',borderRadius:'12px',overflow:'hidden'}}>
              <iframe
                src={`https://www.youtube.com/embed/${playing}?autoplay=1`}
                title="Sewa Bharti Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="absolute inset-0 w-full h-full"
              />
            </div>
            <button
              onClick={() => setPlaying(null)}
              className="absolute -top-12 right-0 flex items-center gap-2 text-white/70 hover:text-white transition text-sm">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
